import { makeStyles } from '@material-ui/core';

export const useSyles = makeStyles({
  container: {
    maxWidth: 'auto',
    maxHeight: '120px',
    padding: '10px 10px 0',
    '&:hover': {
      cursor: 'pointer',
      boxShadow: '1px 1px 6px 0px',
      borderRadius: '10px',
    },
    '& > img': {
      objectFit: 'cover',
      width: '100%',
      height: '100%',
    },
  },
});
